/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dialog } from 'cdk-radial';
import jwt_decode from 'jwt-decode';
import FortellisTermsDialog from '../FortellisTermsDialog/FortellisTermsDialog';
import { ScreenToLoad } from '../ScreenLoader/ScreenLoader';
import {setAmplitudeUserProperties} from '../../utils/amplitude';
import  { AMPLITUDE_PROPERTIES } from '../../constants/amplitudeConstants'
import MainMenu from '../Menu/MainMenu';
import APIDirectory from '../APIBuyer/DealerAPIDirectory/APIDirectory';
import OrderAPIContainer from '../APIBuyer/OrderAPI/OrderAPIContainer';

import {
  getLoginDetails,
  getToken,
  redirect,
  decodedToken,
  setEmail,
  setUserGuid,
  setConnectCdkToken,
  getEntityDetailsById,
} from '../../redux/connectedComponent/loginDetails/loginDetails.slice';
import StepperContainer from '../stepper/StepperContainer';
import { Loading } from '../loader/Loading';
import SubscriptionManagementLandingPage from '../subscriptionManagement/landingPage/SubscriptionManagementLandingPage';
import PurchaseReport from '../PurchaseReport/PurchaseReport';
import DataTransactionReport from '../transaction-report/DataTransactionReport';
import DealerIntegrationReport from '../integration-report/DealerIntegrationReport'
import { useOktaAuth } from "@okta/okta-react";
import { ScreenPaths } from '../../constants/constants';
import { addNavListener } from '../../utils/popstate';
import { environmentURLs } from '../common/CaptureEnvironment';
import NotFound from '../notfound';
import OrderDetails from '../APIBuyer/MyAPIs/OrderDetails';

const {
  MANAGEMENT,
  PURCHASE_HISTORY,
  TRANSACTION_REPORT,
  INTEGRATION_REPORT,
  API_DIRECTORY,
  HOME,
  CHECKOUT,
  MY_APIS,
} = ScreenPaths;

const LoginPage = () => {
  const dispatch = useDispatch();

  const path = window.location?.pathname?.replace(/\/$/, '');
  const pathPattern =
  /^\/dp\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})?$/;

  const transactionReportUrl =  path === `/dp/${TRANSACTION_REPORT}`;
  const purchaseHistoryUrl = path === `/dp/${PURCHASE_HISTORY}`;
  const subManagementUrl = path === `/dp/${MANAGEMENT}`;
  const isIntegrationReportUrl =  path === `/dp/${INTEGRATION_REPORT}`;
  const isHomeUrl = path ===`/dp/${HOME}`;
  const isAPIDirectoryUrl = path === `/dp/${API_DIRECTORY}`;
  const isCheckoutUrl = path === `/dp/${CHECKOUT}`;
  const isMyApisUrl =path === `/dp/${MY_APIS}`;
  const isLoginUrl = path === `/login`
  const originalUrl = localStorage.getItem('returnUrl');
  const isStepperUrl = pathPattern.test(path);

  const urlValidator = (url) => {
    const pathPattern =
      /^\/dp\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})?$/;
    if (
      url === `/dp/${TRANSACTION_REPORT}` ||
      url === `/dp/${PURCHASE_HISTORY}` ||
      url === `/dp/${MANAGEMENT}` ||
      url === `/dp/${INTEGRATION_REPORT}` ||
      url === `/dp/${HOME}` ||
      url === `/dp/${API_DIRECTORY}` ||
      url === `/dp/${CHECKOUT}` ||
      url === '/login' ||
      url === '/' ||
      url === `/dp/${MY_APIS}` ||
      pathPattern.test(url)
    )
      return true;
    return false;
  };

  const uiFactoryState = useSelector(
    state => state.uiFactorySlice
  );
  let screen = uiFactoryState && uiFactoryState.screen;
  let solutionData = uiFactoryState && uiFactoryState.solutionData;
  let additionalData = uiFactoryState && uiFactoryState.additionalData;

  const state = useSelector(state => state);
  const {
    isAuthenticated,
    authenticationToken,
    loginSuccess,
    isLoading,
    isLoginPending,
    isFortellisTermsAndConditionsAccepted,
    errorInGettingDealer,
    hasDAABAccess,
    fortellisEnterpriseEntityId
  } = state.loginDetailsSlice;

  const [showErrorModal, setShowErrorModal] = useState(false);
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    if (!window.location.href.includes('/login')) {
      localStorage.setItem('dplocation', window.location.href);
    }
    if (authenticationToken) {
      let decodeLocalToken = jwt_decode(authenticationToken);
      if (Date.now() > decodeLocalToken.exp * 1000) {
        // invalid token case
        if (!window.location.href.includes('/login')) {
          localStorage.setItem('state', '');
          localStorage.removeItem('dplocationWithoutApp');
          window.location = localStorage.getItem('dplocation');
        }
      }
      localStorage.removeItem('returnUrl')
    }
  }, [authenticationToken, loginSuccess]);

  useEffect(() => {
    const { href } = window.location;
  
    if (!href.includes('/login')) {
      localStorage.setItem('dplocation', href);
      localStorage.removeItem('dplocationWithoutApp');
      return;
    }
  
    else if (isAuthenticated && fortellisEnterpriseEntityId) {
      const baseUrl = href.split('/login')[0];
      const dpPath = hasDAABAccess ? '/dp/home' : '/dp/management';
      const targetUrl = `${baseUrl}${dpPath}`;
      
      localStorage.setItem('dplocationWithoutApp', targetUrl);
      window.location = targetUrl;
    }
  }, [isAuthenticated, hasDAABAccess,fortellisEnterpriseEntityId]);
  

  useEffect(() => {
    if (isAuthenticated) {
      let token = authenticationToken;
      dispatch(decodedToken(token));
    }
  }, [authenticationToken, isAuthenticated]);
  useEffect(()=>{
    if(isAuthenticated){
      let token = authenticationToken;
      dispatch(getEntityDetailsById({id : fortellisEnterpriseEntityId ,token}))
    }
  },[authenticationToken, isAuthenticated,fortellisEnterpriseEntityId])

  useEffect(async ()=>{
    if(!authenticationToken){
      const user = await oktaAuth.getUser();
      const accessToken =
        oktaAuth.authStateManager._authState.accessToken.accessToken;
      const decodedConnectCdkToken = jwt_decode(accessToken);
      dispatch(setConnectCdkToken(accessToken));
      setAmplitudeUserProperties(
        AMPLITUDE_PROPERTIES.ENTERPRISE_ID,
        decodedConnectCdkToken?.enterpriseId
      );
      dispatch(getLoginDetails({ accessToken }));
      dispatch(setEmail(user.cdksid));
      if (user.userGuid) {
        dispatch(setUserGuid(user.userGuid));
      }
    }
  },[authenticationToken])

  useEffect(() => {
    if (state.loginDetailsSlice && state.loginDetailsSlice.canPurchaseDisabled){
      const res = state.loginDetailsSlice.canPurchaseDisabled.filter((arr) =>  arr.entityId === null)

   setShowErrorModal(  res.length > 0 )

    }

  }, [state.loginDetailsSlice.canPurchaseDisabled])

  if (screen) {
    return ScreenToLoad[screen]({solutionData, additionalData});
  }

  if (showErrorModal) {
    return (
      <Dialog
        isOpen={showErrorModal}
        hideCloseButton={false}
        id="overlay-id"
        title={"Error"}
        closeLabel="Close"
        onClose = {() => setShowErrorModal(false)}
      >
        Entity ID is not present for all CMF Numbers
      </Dialog>
    );
  }

  // secondary navigation, used if uiFactorySlice.screen not populated

  if (isLoading) {
    return <Loading active={true} label={''} />;
  }

  if(errorInGettingDealer) {
    return <div className='login-error-message'> User does not have a role assigned to access Fortellis Integration Portal </div>;
  }

  let componentToRender;

  if (isAuthenticated && isFortellisTermsAndConditionsAccepted) {
    switch (true) {
      case isLoginUrl && hasDAABAccess :
         componentToRender = <MainMenu />;
         break;
      case isLoginUrl && !hasDAABAccess :
          componentToRender = <SubscriptionManagementLandingPage />;
          break;
      case hasDAABAccess && isHomeUrl:
        componentToRender = <MainMenu />;
        break;
      case hasDAABAccess && isMyApisUrl:
          componentToRender = <OrderDetails />;
          break;
      case hasDAABAccess &&
        isAPIDirectoryUrl:
        componentToRender = <APIDirectory />;
        break;
      case hasDAABAccess &&
        isCheckoutUrl:
        componentToRender = <OrderAPIContainer />;
        break;
      case isStepperUrl:
        componentToRender = <StepperContainer />;
        break;
      case subManagementUrl:
        componentToRender = <SubscriptionManagementLandingPage />;
        break;
      case purchaseHistoryUrl:
        componentToRender = <PurchaseReport />;
        break;
      case transactionReportUrl:
        componentToRender = <DataTransactionReport />;
        break;
      case environmentURLs.REACT_APP_SHOW_INTEGRATIONS_SCREEN &&
        isIntegrationReportUrl:
        componentToRender = <DealerIntegrationReport />;
        break;
      default:
        break;
    }
  }

  if (
    isFortellisTermsAndConditionsAccepted !== null &&
    !isFortellisTermsAndConditionsAccepted &&
    isAuthenticated
  ) {
    componentToRender = <FortellisTermsDialog />;
  }

  if (
    urlValidator(originalUrl) && !componentToRender
  ) {
    componentToRender = <Loading active={true} label={''} />;
  }
  
  addNavListener(dispatch);
  if(!componentToRender){
    componentToRender = <NotFound />;
  }
  return componentToRender;
};

export default withRouter(LoginPage);
